/** --------------------------------------------------------------------------------------------------
 * 開啟'確認刪除'視窗
 *
 *
 * @param message 要顯示的訊息
 * @param btn_yes 要顯示在 yes/ok 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param btn_no  要顯示在 no/cancel 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param title   標題文字
 * @param observer function 當使用者點選'是'或'否'後,會呼叫的 function;
 *                 使用者點選'btn_yes'會回傳 true;
 *                 使用者點選'btn_no'會回傳 false;
 * @param type    類型 "warning", "error", "success" , "info"
 *
 * -------------------------------------------------------------------------------------------------- */
window.confirmDialog = function ({ message, btn_yes = "確定", btn_cancel, btn_cancel_text = "取消", observer = null }) {

    const box = $("#rd-msg-box");

    box.fadeIn();

    box.find(".rd-msg-txt").text(message);
    box.find(".rd-msg-confirm").find('span').text(btn_yes);
    
    // 先解綁之前的事件，避免重複綁定
    box.find(".rd-msg-confirm").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        if(observer){
            observer()
        }

        box.fadeOut();
        
        return false; // 確保不會觸發任何表單提交
    });
    
    if(btn_cancel){
        box.find(".rd-close-msg-box").show();
        box.find(".rd-close-msg").show();
        box.find(".rd-close-msg").find('span').text(btn_cancel_text);
        
        // 先解綁之前的事件，避免重複綁定
        box.find(".rd-close-msg").off("click").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            box.fadeOut();
            
            return false; // 確保不會觸發任何表單提交
        });
    }else{
        box.find(".rd-close-msg-box").hide();
        box.find(".rd-close-msg").hide();
    }

}
